<template>
  <div class="bilityInfos">
    <div class="bilityInfos-Header">
      <topHeader
        :leftSrc="leftSrc"
        :label="label"
        :textColor="textColor"
        :backgroundColor="backgroundColor"
      ></topHeader>
    </div>
    <div class="bilityInfos-Menu">
      <scrollList
        :menuList="menuList"
        :textColor="textColor"
        :backgroundColor="backgroundColor"
        :activChoose="activChoose"
      >
        <tagDivTag name="one">
          <div class="bilityInfos-box">
            <tableOne :tableId="Number(this.$route.query.id)"></tableOne>
          </div>
        </tagDivTag>
        <tagDivTag name="two">
          <div class="bilityInfos-box">暂无内容</div>
        </tagDivTag>
        <tagDivTag name="three">
          <div class="bilityInfos-box">暂无内容</div>
        </tagDivTag>
        <tagDivTag name="four">
          <div class="bilityInfos-box">
            <tableFour :affairId="Number(this.$route.query.id)"></tableFour>
          </div>
        </tagDivTag>
      </scrollList>
    </div>
  </div>
</template>

<script>
import topHeader from "@/components/header.vue";
import scrollList from "@/components/scrollList.vue";
import tagDivTag from "@/components/tagDivTag.vue";
import tableOne from "@/components/infos/backTableFirst.vue";
import tableFour from "@/components/infos/backTableFour.vue";

export default {
  data() {
    return {
      label: "事项查看",
      backgroundColor: "#ffffff",
      textColor: "#333333",
      leftSrc: require("@/assets/ico@2x.png"),
      // rightIcon: "iconmjiantou-copy",
      // rightText: "返回",
      menuList: [
        {
          Id: 0,
          Name: "权责清单"
        },
        {
          Id: 1,
          Name: "办事指南"
        },
        {
          Id: 2,
          Name: "业务手册"
        },
        {
          Id: 3,
          Name: "意见建议"
        }
      ],
      activChoose: 0
    };
  },
  components: {
    topHeader,
    scrollList,
    tagDivTag,
    tableOne,
    tableFour
  }
};
</script>

<style lang="scss" scoped>
.bilityInfos {
  width: 100%;
  min-height: 100vh;
  height: 100%;
  background-color: #ffffff;
  overflow: hidden;
  .bilityInfos-Menu {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .bilityInfos-Header {
    width: 100%;
    height: auto;
  }
  .bilityInfos-box {
    width: 100%;
    height: 100%;
    padding: 0.25rem 0rem;
    overflow: hidden;
    color: #999999;
  }
}
</style>